import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLowVolume = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 3.5,
			y: 28,
			width: 3,
			height: 9
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 9.5,
			y: 32,
			width: 3,
			height: 5
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 15.5,
			y: 29,
			width: 3,
			height: 8
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 21.5,
			y: 31,
			width: 3,
			height: 6
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 27.5,
			y: 22,
			width: 3,
			height: 15
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 33.5,
			y: 28,
			width: 3,
			height: 9
		})
	]
});
export default SvgLowVolume;
